var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "worksheet-status-icon" }, [
    _c(
      "div",
      { staticClass: "worksheet-status-icon__wrapper" },
      [
        _c("div", { staticClass: "worksheet-status-icon-actions__action" }, [
          _vm.getWorksheetStatus() === "warning"
            ? _c(
                "div",
                {
                  staticClass: "worksheet-status-icon-actions__icon",
                  attrs: { id: "worksheet-warning" },
                },
                [
                  _c(
                    "svg",
                    {
                      attrs: {
                        width: "15",
                        height: "17",
                        viewBox: "0 0 15 17",
                        fill: "none",
                        xmlns: "http://www.w3.org/2000/svg",
                      },
                    },
                    [
                      _c("path", {
                        attrs: {
                          d: "M1 4V3H0V4H1ZM1 16H0V17H1V16ZM11 16V17H12V16H11ZM11 4H12V3H11V4ZM5 10C5 10.5523 5.44772 11 6 11C6.55228 11 7 10.5523 7 10H5ZM7 7C7 6.44772 6.55228 6 6 6C5.44772 6 5 6.44772 5 7H7ZM0 4V16H2V4H0ZM1 17H11V15H1V17ZM10 4V16H12V4H10ZM1 5H11V3H1V5ZM7 10V7H5V10H7Z",
                          fill: "#FFB800",
                        },
                      }),
                      _c("path", {
                        attrs: {
                          d: "M4 4.5V1H14V13H11",
                          stroke: "#FFB800",
                          "stroke-width": "2",
                        },
                      }),
                      _c("circle", {
                        attrs: { cx: "6", cy: "13", r: "1", fill: "#FFB800" },
                      }),
                    ]
                  ),
                ]
              )
            : _vm._e(),
          _vm.getWorksheetStatus() === "success"
            ? _c(
                "div",
                {
                  staticClass: "worksheet-status-icon-actions__icon",
                  attrs: { id: "worksheet-success" },
                },
                [
                  _c(
                    "svg",
                    {
                      attrs: {
                        width: "15",
                        height: "17",
                        viewBox: "0 0 15 17",
                        fill: "none",
                        xmlns: "http://www.w3.org/2000/svg",
                      },
                    },
                    [
                      _c("path", {
                        attrs: {
                          d: "M1 4V3H0V4H1ZM1 16H0V17H1V16ZM11 16V17H12V16H11ZM11 4H12V3H11V4ZM4.70711 9.29289C4.31658 8.90237 3.68342 8.90237 3.29289 9.29289C2.90237 9.68342 2.90237 10.3166 3.29289 10.7071L4.70711 9.29289ZM5 11L4.29289 11.7071C4.68342 12.0976 5.31658 12.0976 5.70711 11.7071L5 11ZM8.70711 8.70711C9.09763 8.31658 9.09763 7.68342 8.70711 7.29289C8.31658 6.90237 7.68342 6.90237 7.29289 7.29289L8.70711 8.70711ZM14 1H15V0H14V1ZM14 13V14H15V13H14ZM4 1V0H3V1H4ZM0 4V16H2V4H0ZM1 17H11V15H1V17ZM10 4V16H12V4H10ZM1 5H11V3H1V5ZM3.29289 10.7071L4.29289 11.7071L5.70711 10.2929L4.70711 9.29289L3.29289 10.7071ZM5.70711 11.7071L8.70711 8.70711L7.29289 7.29289L4.29289 10.2929L5.70711 11.7071ZM13 1V13H15V1H13ZM4 2H14V0H4V2ZM3 1V4.5H5V1H3ZM11 14H14V12H11V14Z",
                          fill: "#12C971",
                        },
                      }),
                    ]
                  ),
                ]
              )
            : _vm._e(),
          _vm.getWorksheetStatus() === "error"
            ? _c(
                "div",
                {
                  staticClass: "worksheet-status-icon-actions__icon",
                  attrs: { id: "worksheet-error" },
                },
                [
                  _c(
                    "svg",
                    {
                      attrs: {
                        width: "15",
                        height: "17",
                        viewBox: "0 0 15 17",
                        fill: "none",
                        xmlns: "http://www.w3.org/2000/svg",
                      },
                    },
                    [
                      _c("path", {
                        attrs: {
                          d: "M1 4V3H0V4H1ZM1 16H0V17H1V16ZM11 16V17H12V16H11ZM11 4H12V3H11V4ZM4.70711 7.29289C4.31658 6.90237 3.68342 6.90237 3.29289 7.29289C2.90237 7.68342 2.90237 8.31658 3.29289 8.70711L4.70711 7.29289ZM7.29289 12.7071C7.68342 13.0976 8.31658 13.0976 8.70711 12.7071C9.09763 12.3166 9.09763 11.6834 8.70711 11.2929L7.29289 12.7071ZM8.70711 8.70711C9.09763 8.31658 9.09763 7.68342 8.70711 7.29289C8.31658 6.90237 7.68342 6.90237 7.29289 7.29289L8.70711 8.70711ZM3.29289 11.2929C2.90237 11.6834 2.90237 12.3166 3.29289 12.7071C3.68342 13.0976 4.31658 13.0976 4.70711 12.7071L3.29289 11.2929ZM14 1H15V0H14V1ZM14 13V14H15V13H14ZM4 1V0H3V1H4ZM0 4V16H2V4H0ZM1 17H11V15H1V17ZM10 4V16H12V4H10ZM1 5H11V3H1V5ZM3.29289 8.70711L5.29289 10.7071L6.70711 9.29289L4.70711 7.29289L3.29289 8.70711ZM5.29289 10.7071L7.29289 12.7071L8.70711 11.2929L6.70711 9.29289L5.29289 10.7071ZM7.29289 7.29289L5.29289 9.29289L6.70711 10.7071L8.70711 8.70711L7.29289 7.29289ZM5.29289 9.29289L3.29289 11.2929L4.70711 12.7071L6.70711 10.7071L5.29289 9.29289ZM13 1V13H15V1H13ZM4 2H14V0H4V2ZM3 1V4.5H5V1H3ZM11 14H14V12H11V14Z",
                          fill: "#FF238D",
                        },
                      }),
                    ]
                  ),
                ]
              )
            : _vm._e(),
        ]),
        _vm.getWorksheetStatus() === "success"
          ? _c(
              "b-popover",
              {
                attrs: {
                  triggers: "hover",
                  placement: "bottomright",
                  target: "worksheet-success",
                },
              },
              [_vm._v(" Анкета заполнена ")]
            )
          : _vm._e(),
        _vm.getWorksheetStatus() === "error"
          ? _c(
              "b-popover",
              {
                attrs: {
                  triggers: "hover",
                  placement: "bottomright",
                  target: "worksheet-error",
                },
              },
              [_vm._v(" Анкета не заполнена ")]
            )
          : _vm._e(),
        _vm.getWorksheetStatus() === "warning"
          ? _c(
              "b-popover",
              {
                attrs: {
                  triggers: "hover",
                  placement: "bottomright",
                  target: "worksheet-warning",
                },
              },
              [
                _c(
                  "div",
                  { staticClass: "worksheet-status-icon__worksheet-tooltip" },
                  [
                    _c(
                      "div",
                      {
                        staticClass:
                          "worksheet-status-icon__worksheet-tooltip-title",
                      },
                      [_vm._v("Заполнено")]
                    ),
                    _c("table", [
                      _c("tr", [
                        _c(
                          "td",
                          {
                            staticClass:
                              "worksheet-status-icon__worksheet-tooltip-meta",
                          },
                          [_vm._v("Обязательных полей")]
                        ),
                        _c("td", [
                          _vm._v(
                            _vm._s(
                              _vm.required !== undefined
                                ? _vm.required.count
                                : null
                            )
                          ),
                        ]),
                        _c("td", [
                          _vm._v(
                            _vm._s(
                              _vm.required !== undefined
                                ? _vm.required.percentage
                                : null
                            ) + "%"
                          ),
                        ]),
                      ]),
                      _c("tr", [
                        _c(
                          "td",
                          {
                            staticClass:
                              "worksheet-status-icon__worksheet-tooltip-meta",
                          },
                          [_vm._v("Дополнительных полей")]
                        ),
                        _c("td", [
                          _vm._v(
                            _vm._s(
                              _vm.additional !== undefined
                                ? _vm.additional.count
                                : null
                            )
                          ),
                        ]),
                        _c("td", [
                          _vm._v(
                            _vm._s(
                              _vm.additional !== undefined
                                ? _vm.additional.percentage
                                : null
                            ) + "%"
                          ),
                        ]),
                      ]),
                      _c("tr", [
                        _c(
                          "td",
                          {
                            staticClass:
                              "worksheet-status-icon__worksheet-tooltip-meta",
                          },
                          [_vm._v("Всего")]
                        ),
                        _c("td", [
                          _vm._v(
                            _vm._s(
                              _vm.total !== undefined ? _vm.total.count : null
                            )
                          ),
                        ]),
                        _c("td", [
                          _vm._v(
                            _vm._s(
                              _vm.total !== undefined
                                ? _vm.total.percentage
                                : null
                            ) + "%"
                          ),
                        ]),
                      ]),
                    ]),
                  ]
                ),
              ]
            )
          : _vm._e(),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }